import {
	createMetaAccount,
	getMetaAccounts,
	updateMetaAccount,
} from '@/API/repositories/meta';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useEffect, useState } from 'react';

const useMetaAccountsList = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [accounts, setAccounts] = useState();
	const [selectedMetaAccountForm, setSelectedMetaAccountForm] = useState(false);
	const [selectedAddAccountForm, setSelectedAddAccountForm] = useState(false);
	const [showSyncPopup, setShowSyncPopup] = useState(false);

	const isLoading = hasUnfilledRequest(
		getMetaAccounts,
		updateMetaAccount,
		createMetaAccount,
	);

	const loadData = async () => {
		const { data } = await makeRequest(getMetaAccounts);

		data.forEach((metaAccount) =>
			metaAccount._add_account.sort((a, b) => {
				if (a.is_active !== b.is_active) {
					return a.is_active ? -1 : 1;
				}
				return a.name.localeCompare(b.name);
			}),
		);

		if (data) {
			setAccounts(data);
		}
	};

	useEffect(() => {
		if (!selectedMetaAccountForm && !selectedAddAccountForm) {
			loadData();
		}
	}, [selectedMetaAccountForm, selectedAddAccountForm]);

	return {
		accounts,
		isLoading,
		selectedMetaAccountForm,
		setSelectedMetaAccountForm,
		selectedAddAccountForm,
		setSelectedAddAccountForm,
		showSyncPopup,
		setShowSyncPopup,
	};
};

export default useMetaAccountsList;
